export class ChargebackFacade {
  merchantId: string;
  processor: string;
  caseNumber: string;
  actionDate: string;
  transactionDate: string;
  chargebackAmount: number;
  transactionAmount: string;
  dba: string | undefined;
  reasonCode: string | undefined;
  reasonDescription: string | undefined;
  status: string | undefined;
  cardNumber: string | undefined;
  settlementMethod: string | undefined;
  paymentReference: string | undefined;

  constructor(chargeback: Partial<ChargebackFacade>) {
    if (chargeback.merchantId == undefined) {
      throw 'merchantId required on transaction';
    }
    if (chargeback.processor == undefined) {
      throw 'processor required on transaction';
    }
    if (chargeback.caseNumber == undefined) {
      throw 'caseNumber required on transaction';
    }
    if (chargeback.actionDate == undefined) {
      throw 'chargebackDate required on transaction';
    }
    if (chargeback.transactionDate == undefined) {
      throw 'transactionDate required on transaction';
    }
    if (chargeback.chargebackAmount == undefined) {
      throw 'chargebackAmount required on transaction';
    }
    if (chargeback.transactionAmount == undefined) {
      throw 'transactionAmount required on transaction';
    }

    this.merchantId = chargeback.merchantId;
    this.processor = chargeback.processor;
    this.caseNumber = chargeback.caseNumber;
    this.actionDate = chargeback.actionDate;
    this.transactionDate = chargeback.transactionDate;
    this.chargebackAmount = chargeback.chargebackAmount;
    this.transactionAmount = chargeback.transactionAmount;
    this.dba = chargeback.dba;
    this.reasonCode = chargeback.reasonCode;
    this.reasonDescription = chargeback.reasonDescription;
    this.status = chargeback.status;
    this.paymentReference = chargeback.paymentReference;
    this.cardNumber = chargeback.cardNumber;
    this.settlementMethod = chargeback.settlementMethod;
  }
}
